import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, Injector, NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { BusyConfig } from 'ng-busy';
import { PensionOutlookService } from '../modules/pension-outlook/services/pension-outlook.service';
import { RoutingService } from './services/routing.service';

export function busyConfigFactory() {
  return new BusyConfig({
    message: 'Loading...',
    delay: 500
  });
}

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  exports: [

    HttpClientModule,
    RouterModule
  ],
  declarations: [
  ],
  providers: [
    RoutingService,
    PensionOutlookService,
    {
      provide: BusyConfig,
      useFactory: busyConfigFactory
    },
  ]
})
export class CoreModule {
  static injector: Injector;

  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    injector: Injector,
    library: FaIconLibrary
  ) {
    CoreModule.injector = injector;
    library.addIconPacks(fab, far, fas);
  }
}
